/**
 * Legacy size tokens (non-linear scale for various UI elements).
 * @deprecated Use the new size tokens (si0, si1, etc.) instead.
 */
export const sizeLegacy = {
  $0: 0,
  "$0.25": 2,
  "$0.5": 4,
  "$0.75": 8,
  $1: 20,
  "$1.5": 24,
  $2: 28,
  "$2.5": 32,
  $3: 36,
  "$3.5": 40,
  $4: 44,
  $true: 44,
  "$4.5": 48,
  $5: 52,
  "$5.5": 58,
  $6: 64,
  $7: 74,
  $8: 84,
  $9: 94,
  $10: 104,
  $11: 124,
  $12: 144,
  $13: 164,
  $14: 184,
  $15: 204,
  $16: 224,
  $17: 224,
  $18: 244,
  $19: 264,
  $20: 284,
  $21: 304,
  $22: 324,
} as const;

// Helper type to strip $ prefix (distributive over union)
type StripDollarPrefix<T> = T extends `$${infer Key}` ? Key : T;

type SizeLegacyKeysIn = keyof typeof sizeLegacy;

/**
 * @deprecated Use `SizeTokensKeys` instead
 */
export type SizeLegacyKeys = StripDollarPrefix<SizeLegacyKeysIn>;
